import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { parseCallApi } from "./parseCallApi.js";
import { replaceBindings } from "./replaceBindings.js";
export function parseResourceCall(path, state, app, options, name, config, transformArgs, method) {
  var payload = parseCallApi(path, state, app, options);
  if (!payload) {
    return null;
  }
  state.contracts.add(payload.api);
  var dataSource = _objectSpread({
    name: name,
    config: config
  }, payload);
  if (transformArgs && method) {
    if (method === "catch") {
      if (transformArgs.length !== 1) {
        state.errors.push({
          message: "\".catch()\" expects exactly 1 argument, but got ".concat(transformArgs.length),
          node: transformArgs.length > 0 ? transformArgs[1].node : path.node,
          severity: "error"
        });
        return null;
      }
    } else {
      if (transformArgs.length === 0 || transformArgs.length > 2) {
        state.errors.push({
          message: "\".then()\" expects 1 or 2 arguments, but got ".concat(transformArgs.length),
          node: transformArgs.length > 2 ? transformArgs[2].node : path.node,
          severity: "error"
        });
        return null;
      }
    }
    var transform = parsePromiseCallback(transformArgs[0], state, app, options, method);
    if (transform) {
      dataSource[method === "catch" ? "rejectTransform" : "transform"] = transform;
    }
    if (method !== "catch" && transformArgs.length > 1) {
      var rejectTransform = parsePromiseCallback(transformArgs[1], state, app, options, method);
      if (rejectTransform) {
        dataSource.rejectTransform = rejectTransform;
      }
    }
  }
  return dataSource;
}
function parsePromiseCallback(callback, state, app, options, method) {
  if (!callback.isArrowFunctionExpression()) {
    state.errors.push({
      message: "\".".concat(method, "()\" callback expects an arrow function, but got ").concat(callback.type),
      node: callback.node,
      severity: "error"
    });
    return null;
  }
  var body = callback.get("body");
  if (!body.isExpression()) {
    state.errors.push({
      message: "\".".concat(method, "()\" callback function body expects an expression, but got ").concat(body.type),
      node: body.node,
      severity: "error"
    });
    return null;
  }
  var params = callback.get("params");
  if (params.length > 1) {
    var _params$1$node, _params$;
    state.errors.push({
      message: "\".".concat(method, "()\" callback function expects exactly 0 or 1 parameter, but got ").concat(params.length),
      node: (_params$1$node = (_params$ = params[1]) === null || _params$ === void 0 ? void 0 : _params$.node) !== null && _params$1$node !== void 0 ? _params$1$node : callback,
      severity: "error"
    });
    return null;
  }
  var optionsWithData = _objectSpread(_objectSpread({}, options), {}, {
    dataBinding: undefined
  });
  var arg = params[0];
  if (params.length > 0) {
    if (!arg.isIdentifier()) {
      state.errors.push({
        message: "\".".concat(method, "()\" callback function parameter expects an identifier, but got ").concat(arg.type),
        node: arg.node,
        severity: "error"
      });
      return null;
    }
    optionsWithData.dataBinding = {
      id: arg.node
    };
  }
  return replaceBindings(body, state, app, optionsWithData);
}
//# sourceMappingURL=parseResourceCall.js.map